<template>
  <div>
    <el-dialog title="人群运算" :before-close="handleClose" :visible.sync="taskDialog" width="1000px">
      <div class="precisionTask">
        <div style="color: red">*运算完成后的人群包会展示在客户分群列表中</div>
        <div class="tab-line">
          <div class="tab-item" :class="{ active: taskForm.type == 1 }"
            :style="{ color: taskForm.type == 1 ? globalBG : '', 'border-top': taskForm.type == 1 ? '2px solid ' + globalBG : '', }"
            @click="taskForm.type = 1">
            人群交并差运算
            <span></span>
          </div>
          <div class="tab-item" :class="{ active: taskForm.type == 2 }"
            :style="{ color: taskForm.type == 2 ? globalBG : '', 'border-top': taskForm.type == 2 ? '2px solid ' + globalBG : '', }"
            @click="taskForm.type = 2">
            人群抽取运算
            <span></span>
          </div>
        </div>
        <!-- 人群交并差 -->
        <div v-if="taskForm.type == 1" style="margin-top: 20px;">
          <p class="tip">支持对多个人群进行交并差计算</p>
          <div class="form-lable" style="display: block;">
            <div class="item-label"><span>*</span>任务名称：</div>
            <div class="item-value">
              <el-input placeholder="请输入任务名称方便后续区分" v-model="taskForm.taskName" maxlength="32" show-word-limit
                style="width: 250px;" class="ex-input"></el-input>
            </div>
          </div>
          <div class="form-lable">
            <div class="item-label"><span>*</span>人群名称：</div>
            <div class="item-value">
              <el-input placeholder="请输入人群名称" v-model="taskForm.crowName" maxlength="50" show-word-limit
                style="width: 200px;" class="ex-input"></el-input>
            </div>
          </div>
          <div class="form-lable" style="margin-left: 24px;">
            <div class="item-label"><span>*</span>人群描述：</div>
            <div class="item-value">
              <el-input placeholder="请输入人群描述" v-model="taskForm.description" maxlength="50" show-word-limit
                style="width: 200px;" class="ex-input"></el-input>
            </div>
          </div>
          <div class="form-lable" style="margin-left: 24px;">
            <div class="item-label"><span>*</span>选择分类：</div>
            <div class="item-value">
              <el-select v-model="classifyId" style="width: 200px;" class="ex-input">
                <el-option :value="0" label="默认分组"></el-option>
                <el-option 
                  v-for="(item, index) in classPeopleList"
                  :key="index"
                  :value="item.classifyId"
                  :label="item.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 选择人群 -->
          <div class="form-item" style="margin-top: 40px;">
            <div class="item-label"><span style="color: red;">*</span>选择人群：</div>
            <div class="item-value">
              <div class="select-people-box">
                <div class="select-header">
                  <el-button type="primary" @click="showPeopleDialog('0')"
                    style="margin-right: 12px; font-size: 14px; height: 28px">选择人群</el-button>
                  <span>已选</span>
                  <span class="height-num" style="color: #fe4d45">{{
                    includeCrowd.length
                  }}</span>
                  <span>个人群</span>
                  <div class="operation-wrapper">
                    <span>运算规则：</span>
                    <el-radio-group v-model="includeRule">
                      <el-radio :label="1">合并</el-radio>
                      <el-radio :label="0">交集</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="people-group">
                  <div class="group-item" v-for="(item, index) in includeCrowd" :key="index">
                    <div class="group-name">
                      {{ item.name || item.strategyName }}
                      <span style="color: #7f85e9">（{{ item.count }}）</span>
                    </div>
                    <div class="close" @click="delPeople('0', index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 是否排除人群 -->
          <div class="form-item" style="margin-left:15px;">
            <div class="item-label"></div>
            <div class="item-value">
              <el-checkbox v-model="excludeFlag" :label="true" style="z-index: 0;">&nbsp;</el-checkbox>排除人群
            </div>
          </div>
          <!-- 排除人群 -->
          <div class="form-item" v-if="excludeFlag" style="margin-left: 85px;">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="select-people-box">
                <div class="select-header">
                  <el-button class="computeLoadingButtom" style="margin-right: 12px"
                    @click="showPeopleDialog('1')">选择人群</el-button>
                  <span>已选</span>
                  <span class="height-num" style="color: #fe4d45">{{
                    excludeCrowd.length
                  }}</span>
                  <span>个人群</span>
                  <div class="operation-wrapper">
                    <span>运算规则：</span>
                    <el-radio-group v-model="excludeRule">
                      <el-radio :label="1">合并</el-radio>
                      <el-radio :label="0">交集</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="people-group">
                  <div class="group-item" v-for="(item, index) in excludeCrowd" :key="index">
                    <div class="group-name">
                      {{ item.name || item.strategyName
                      }}<span style="color: #7f85e9">（{{ item.count }}）</span>
                    </div>
                    <div class="close" @click="delPeople('1', index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 人群抽取 -->
        <div v-if="taskForm.type == 2" style="margin-top: 20px;">
          <p class="tip">支持对单个人群进行抽取计算</p>
          <div class="form-lable" style="display: block;">
            <div class="item-label"><span>*</span>任务名称：</div>
            <div class="item-value">
              <el-input placeholder="请输入任务名称方便后续区分" v-model="taskForm.taskName" maxlength="32" show-word-limit
                style="width: 250px; " class="ex-input"></el-input>
            </div>
          </div>
          <div class="form-item" style="margin-top: 40px;">
            <div class="item-label"><span style="color: red;">*</span>选择人群：</div>
            <div class="item-value">
              <div class="select-people-box">
                <div class="select-header">
                  <el-button type="primary" @click="showPeopleDialog('2')"
                    style="margin-right: 12px; font-size: 14px; height: 28px">选择人群</el-button>
                  <span>已选</span>
                  <span class="height-num" style="color: #fe4d45">{{
                    extractCrowd.length
                  }}</span>
                  <span>个人群</span>
                </div>
                <div class="people-group">
                  <div class="group-item" v-for="(item, index) in extractCrowd" :key="index">
                    <div class="group-name">
                      {{ item.name || item.strategyName }}
                      <span style="color: #7f85e9">（{{ item.count }}）</span>
                    </div>
                    <div class="close" @click="delPeople('2', index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-lable" style="display: block;">
            <div class="item-label"><span>*</span>抽取方式：</div>
            <div class="item-value">
              <el-radio-group v-model="rule" @change="changeRule">
                <el-radio :label="1">按比例抽取</el-radio>
                <el-radio :label="2">按人数抽取</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="form-lable" style="display: block;">
            <div class="item-label">&nbsp;&nbsp;分组排布：</div>
            <div class="item-values" v-if="rule == 1">
              <div v-for="(item, index) in subList" :key="index">
                <span><span style="display: inline-block;width: 25px;text-align: right;">{{ index + 1
                }}.&nbsp;</span>拆分人群：</span>
                <el-input v-model="item.num" style="width: 140px;"
                  @input.native="checkputn($event)" />&nbsp;<span>%</span>&nbsp;&nbsp;
                <span>人群名称：</span><el-input v-model="item.name" style="width: 140px;" maxlength="50" show-word-limit
                  class="ex-input" />&nbsp;&nbsp;
                <span>人群描述：</span><el-input v-model="item.description" style="width: 140px;" maxlength="50"
                  show-word-limit class="ex-input" />&nbsp;&nbsp;
                <el-button class="computeLoadingButtom" v-if="index != 0" @click="delGroup(index)">删除</el-button>
              </div>
              <div class="form-lable" style="display: block;">
              <div class="item-label"><span>*</span>选择分类：</div>
                <div class="item-value">
                  <el-select v-model="classifyId" style="width: 200px;" class="ex-input">
                    <el-option :value="0" label="默认分组"></el-option>
                    <el-option 
                      v-for="(item, index) in classPeopleList"
                      :key="index"
                      :value="item.classifyId"
                      :label="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-values" v-else>
              <div v-for="(item, index) in subPeopleList" :key="index">
                <span><span style="display: inline-block;width: 25px;text-align: right;">{{ index + 1
                }}.&nbsp;</span>拆分人群：</span>
                <el-input v-model="item.num" style="width: 140px;"
                  @input.native="checkputn($event)" />&nbsp;<span>人</span>&nbsp;&nbsp;
                <span>人群名称：</span><el-input v-model="item.name" style="width: 140px;" maxlength="50" show-word-limit
                  class="ex-input" />&nbsp;&nbsp;
                <span>人群描述：</span><el-input v-model="item.description" style="width: 140px;" maxlength="50"
                  show-word-limit class="ex-input" />&nbsp;&nbsp;
                <el-button class="computeLoadingButtom" v-if="index != 0" @click="delGroup1(index)">删除</el-button>
              </div>
              <div class="form-lable" style="display: block;">
                <div class="item-label"><span>*</span>选择分类：</div>
                <div class="item-value">
                  <el-select v-model="classifyId" style="width: 200px;" class="ex-input">
                    <el-option :value="0" label="默认分组"></el-option>
                    <el-option 
                      v-for="(item, index) in classPeopleList"
                      :key="index"
                      :value="item.classifyId"
                      :label="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            
          </div>
          <div class="form-lable" style="display: block;">
            <div class="item-label">&nbsp;&nbsp;&nbsp;</div>
            <div class="item-value">
              <el-button type="primary" @click="addGroup" :disabled="rule == 1 && subList.length >= 10">+添加分组</el-button>
              <el-button class="computeLoadingButtom" v-if="rule == 1" @click="allocation">等比例分配</el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: -20px">
        <el-button type="primary" @click="saveCrowdTask">确认运算</el-button>
        <el-button @click="handleClose" style="border: 1px solid #ddd">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 选择人群 -->
    <select-people :peopleList="showSelectPeople" v-if="selectPeopleDialog" @onConfirm="handleSelectPeople"
      @onCancle="canclePeople" :selectPeopleDialog="selectPeopleDialog"></select-people>
    <select-people-one :peopleList="showSelectPeople" v-if="selectPeopleOneDialog" @onConfirm="handleSelectPeopleOne"
      @onCancle="canclePeople" :selectPeopleDialog="selectPeopleOneDialog"></select-people-one>
  </div>
</template>

<script>
import selectPeople from "@/components/select-people.vue";
import selectPeopleOne from "@/components/select-people-one.vue";

import { postPrecisionCrowdTask } from "@/api/precisionCrowdTask"
import {queryCrowdClassify} from "@/api/manage/memberCrowdController";

import { mapState } from "vuex";

export default {
  props: {
    taskDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    selectPeople,
    selectPeopleOne
  },
  data() {
    return {
      taskForm: { // 保存人群运算任务
        type: 1
      },
      selectPeopleDialog: false, // 选择人群弹窗
      selectPeopleOneDialog: false, // 选择人群弹窗
      showSelectPeople: [], // 回显已选择人群
      includeCrowd: [], // 已选择人群
      excludeCrowd: [], // 已排除人群
      extractCrowd: [], // 抽取的人群
      excludeFlag: false, // 是否勾选排除人群
      includeRule: 1,  // 包含人群人群 交并差
      excludeRule: 1,  // 排除人群  交并差
      peopleType: "0",  // 选择人群 or 排除人群
      rule: 1, // 抽取方式
      subList: [], // 分组排布列表
      subPeopleList: [], // 分组排布列表
      defaultContent: "", // 默认名称
      classPeopleList:[], // 分类选项列表
      classifyId:0, // 选择分类
    }
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
      globalBG: "globalBG",
    }),
  },
  created() {
    let createTimes = this.getFormatDate()
    // console.log(createTimes);
    // createTimes = createTimes.slice(0,4)+'-'+slice(5,4)+'-'+slice(0,4)+
    this.defaultContent = '运算人群' + createTimes
    // this.taskForm = {
    //   type: 1,
    //   taskName: '运算人群' + createTimes,
    //   description: '运算人群' + createTimes,
    //   crowName: '运算人群' + createTimes,
    // }
  },
  mounted() {
    this.subList.push({ num: "", name: this.defaultContent, description: this.defaultContent })
    this.subPeopleList.push({ num: "", name: this.defaultContent, description: this.defaultContent })
    this.taskForm = {
      type: 1,
      taskName: this.defaultContent,
      description: this.defaultContent,
      crowName: this.defaultContent,
    }
    this.getClassOptions();
  },
  methods: {
    // 创建人群运算--保存
    saveCrowdTask() {
      let param = this.getParams()
      console.log('创建运算', param);
      if (!param) return
      postPrecisionCrowdTask(param).then(res => {
        if (res.code == 1) {
          this.$message.success("创建运算成功")
        } else {
          this.$message.warning(res.message)
        }
        this.$emit('close')
      })
    },
    // 获取参数&&验证
    getParams() {
      let form = this.taskForm
      if (!form.taskName) {
        this.$message.warning("请填写任务名称")
        return
      }
      if (form.type == 1) {
        // 交并
        if (!form.crowName) {
          this.$message.warning("请填写人群名称")
          return
        }
        if (!form.description) {
          this.$message.warning("请填写人群描述")
          return
        }
        if (this.includeCrowd.length == 0) {
          this.$message.warning("请选择人群")
          return
        }
        if (this.excludeFlag && this.excludeCrowd.length == 0) {
          this.$message.warning("请选择需要排除的人群")
          return
        }
        // 选择人群
        var includeIds = [];
        var excludeIds = [];
        var includeSearchIds = [];
        var excludeSearchIds = [];
        // 选择人群
        this.includeCrowd.forEach((item, index) => {
          var temp = {
            precisionCrowdStrategyId: item.precisionCrowdStrategyId,
            name: item.name,
            count: item.count,
          };
          if (item.searchId && item.searchId.length > 0) {
            temp.searchId = item.searchId;
            includeSearchIds.push(temp);
          } else {
            temp.strategy = item.strategy;
            includeIds.push(temp);
          }
        });
        // 排除人群
        this.excludeCrowd.forEach((item) => {
          var temp = {
            precisionCrowdStrategyId: item.precisionCrowdStrategyId,
            name: item.name,
          };

          if (item.searchId && item.searchId.length > 0) {
            temp.searchId = item.searchId;
            excludeSearchIds.push(temp);
          } else {
            temp.strategy = item.strategy;
            excludeIds.push(temp);
          }
        });
        // console.log(createTimes);
        return {
          taskName: form.taskName,
          description: form.description,
          crowName: form.crowName,
          type: 1,
          selectedCrowd: {
            includeCrowd: includeIds,         // 选择人群
            includeRule: this.includeRule,    // 人群运算规则
            excludeFlag: this.excludeFlag ? '1' : '0',    // 是否排除人群
            excludeCrowd: excludeIds,         // 排除人群
            excludeRule: this.excludeRule,    // 排除人群运算规则
            includeSearchId: includeSearchIds,
            excludeSearchId: excludeSearchIds,
            classifyId:this.classifyId
          }
        }
      } else if (form.type == 2) {
        // 抽取
        if (this.extractCrowd.length == 0) {
          this.$message.warning("请选择人群")
          return
        }
        let flag = false
        // 按比例抽取
        if (this.rule == 1) {
          let sub = 0
          this.subList.forEach(item => {
            sub += Number(item.num)
            if (item.num == "") {
              this.$message.warning("请填写人群比例")
              flag = true
              return
            }
            if (item.name == "") {
              this.$message.warning("请填写人群名称")
              flag = true
              return
            }
            if (item.description == "") {
              this.$message.warning("请填写人群描述")
              flag = true
              return
            }
          })
          if (flag) return false
          if (sub > 100) {
            this.$message.warning("人群拆分比例不得超过100%")
            return
          }
        } else {
          let sub = 0
          this.subPeopleList.forEach(item => {
            sub += Number(item.num)
            if (item.num == "") {
              this.$message.warning("请填写人群数量")
              flag = true
              return
            }
            if (item.name == "") {
              this.$message.warning("请填写人群名称")
              flag = true
              return
            }
            if (item.description == "") {
              this.$message.warning("请填写人群描述")
              flag = true
              return
            }
          })
          if (flag) return false
          if (sub > this.extractCrowd[0].count) {
            this.$message.warning("人群拆分人群人数总和不得超过选择的人群人数")
            return
          }
        }
        var extractCrowdone = {
          precisionCrowdStrategyId: this.extractCrowd[0].precisionCrowdStrategyId,
          name: this.extractCrowd[0].name,
          searchId: this.extractCrowd[0].searchId,
          num: this.extractCrowd[0].count
        }
        var sendSubRule = {
          subList: this.rule == 1 ? this.subList : this.subPeopleList,
          rule: this.rule
        }
        var cParams = {
          taskName: form.taskName,
          type: 2,
          selectedCrowd: {
            extractCrowd: extractCrowdone,
            subRule: sendSubRule,
            classifyId:this.classifyId
          }
        }
        return cParams
      }
    },
    // 关闭
    handleClose() {
      this.$emit('close')
    },
    // 选择人群
    showPeopleDialog(type) {
      this.peopleType = type
      if (type == "0") {
        this.showSelectPeople = this.includeCrowd;
        this.selectPeopleDialog = true;
      } else if (type == "1") {
        this.showSelectPeople = this.excludeCrowd;
        this.selectPeopleDialog = true;
      } else if (type == "2") {
        this.showSelectPeople = this.extractCrowd;
        this.selectPeopleOneDialog = true
      }
    },
    // 返回选择的人群
    handleSelectPeople(obj) {
      console.log(obj);
      this.selectPeopleDialog = false;
      if (this.peopleType == "0") {
        // 包含人群
        this.includeCrowd = obj;
      } else if (this.peopleType == "1") {
        // 排除人群
        this.excludeCrowd = obj;
      }
    },
    // 返回选择的人群--抽取人群，单选
    handleSelectPeopleOne(obj) {
      console.log(obj);
      this.selectPeopleOneDialog = false;
      // 抽取人群
      this.extractCrowd = obj
    },
    delPeople(type, index) {
      if (this.computeLoading) {
        return;
      }
      if (type == "0") {
        this.includeCrowd.splice(index, 1);
      } else if (type == "1") {
        this.excludeCrowd.splice(index, 1);
      } else if (type == "2") {
        this.extractCrowd.splice(index, 1);
      }
    },
    // 改变抽取方式--分组
    changeRule() {
    },
    // 添加分组
    addGroup() {
      if (this.rule == 1) {
        this.subList.push({ num: "", name: this.defaultContent, description: this.defaultContent })
      } else {
        this.subPeopleList.push({ num: "", name: this.defaultContent, description: this.defaultContent })
      }

    },
    // 按比例分配
    allocation() {
      let num = this.subList.length
      let oneSub = Math.floor(100 / num * 100) / 100
      this.subList.forEach(item => {
        item.num = oneSub
      })
    },
    // 删除分组
    delGroup(idx) {
      this.subList.splice(idx, 1)
    },
    delGroup1(idx) {
      this.subPeopleList.splice(idx, 1)
    },
    // 取消选择人群
    canclePeople() {
      this.selectPeopleDialog = false;
      this.selectPeopleOneDialog = false;
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/[^.-?\d]/g, "");
      if (this.rule == 1) {
        let sub = 0
        this.subList.forEach(item => {
          sub += Number(item.num)
        })
        if (sub > 100) {
          this.$message.warning("人群拆分比例不得超过100%")
          return
        }
      }
      if (this.rule == 2 && this.extractCrowd.length) {
        let sub = 0
        this.subPeopleList.forEach(item => {
          sub += Number(item.num)
        })
        if (sub > this.extractCrowd[0].count) {
          this.$message.warning("人群拆分人群人数总和不得超过选择的人群人数")
          return
        }
      }
      e.target.value = filtered;
    },
    getFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      month = (month < 10) ? '0' + month : month;
      day = (day < 10) ? '0' + day : day;
      hour = (hour < 10) ? '0' + hour : hour;
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      let currentDate = year + "-" + month + "-" + day
        + " " + hour + ":" + minutes + ":" + seconds;
      return currentDate;
    },
    // 分类选项列表
    getClassOptions(){
      queryCrowdClassify(12).then(res=>{
        this.classPeopleList = res.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.precisionTask {
  .radioBox {
    margin-top: 20px;

    span {
      font-size: 16px;
    }
  }

  .tip {
    color: red;
    margin-left: 15PX;
    margin-top: 30PX;
  }
}

.form-item {
  margin-bottom: 16px;

  &>div {
    display: inline-block;
  }

  .item-label {
    // width: 154px;
    text-align: right;
    // padding-right: 8px;
    box-sizing: border-box;
    vertical-align: text-top;
    line-height: 32px;
  }

  .item-value {
    width: 802px;
    vertical-align: text-top;

    .select-people-box {
      .select-header {
        // @media screen and (max-width: 1366px) {
        //   width: 800px;
        // }

        background: #f6f6f6;
        position: relative;
        padding: 8px;

        .computeLoadingButtom {
          width: 98px;
          height: 28px;
          color: #fe4d45;
          border-radius: 3px;
          border: 1px solid #fe4d45;
          background-color: #fff;

          &:hover {
            color: #fff;
            border: 1px solid #fff;
            background-color: #fe4d45;
          }

          &:active {
            color: #fff;
            border: 1px solid #fff;
            background-color: #fe4d45;
          }
        }

        .height-num {
          color: #7f85e9;
          margin: 0 4px;
        }

        .operation-wrapper {
          position: absolute;
          right: 20px;
          transform: translateY(-50%);
          top: 50%;
        }
      }

      .people-group {
        border: 1px solid rgba(246, 246, 246, 1);
        color: #999;
        padding-top: 14px;

        // margin-bottom: 20px;
        .group-item {
          // padding: 14px 12px;
          position: relative;
          display: inline-block;
          line-height: 32px;
          height: 32px;
          border: 1px solid rgba(238, 238, 238, 1);
          border-radius: 2px;
          color: #666666;
          margin-left: 10px;
          margin-bottom: 14px;
          position: relative;

          // &.group-item:nth-child(4n){
          //   margin-right: 0;
          // }
          .group-name {
            // width: 210px;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            overflow: hidden;
            // border:1px solid #CCCCCC;
            padding: 0 12px;
          }

          .close {
            display: none;
            position: absolute;
            right: -6px;
            top: -6px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            cursor: pointer;
            background-color: #fe4d45;

            // display: none;
            &:before,
            &:after {
              position: absolute;
              top: 4px;
              left: 7px;
              content: " ";
              height: 8px;
              width: 2px;
              background-color: #fff;
            }

            &:before {
              transform: rotate(45deg);
            }

            &:after {
              transform: rotate(-45deg);
            }
          }

          &:hover .close {
            display: inline-block;
          }
        }
      }
    }
  }
}

.form-lable {
  display: inline-block;
  margin-top: 40px;

  &>div {
    display: inline-block;
  }

  .item-label {
    // vertical-align: text-top;

    span {
      color: red;
    }
  }

  .item-values {
    // width: 802px;
    // margin-left: 10px;
    vertical-align: text-top;
    margin-top: -18px;

    &>div {
      margin-top: 10px;
    }
  }

  .computeLoadingButtom {
    width: 98px;
    height: 30px;
    color: #fe4d45;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fff;

    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }

    &:active {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
}

.compute-people {
  // position: absolute;
  font-size: 14px;
  color: #333;

  &>span {
    vertical-align: text-top;
  }

  .item-name {
    width: 162px;
    display: inline-block;
    vertical-align: text-top;
  }

  .handleCaculateButtom {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;
    margin-top: -10px;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .el-button {
    margin-right: 12px;
  }

  .height-num {
    padding: 0 8px;
  }

  .el-button {
    margin-left: 12px;
  }
}

.item-value2 {
  vertical-align: text-top;
  // margin-top: -10px;
}

.tab-line {
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #dddddd;
  // margin: 20px 28px 0 28px;
  margin-bottom: 20px;
  margin-top: 20px;

  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;

    // &:first-child{
    //   margin-right: 22px;
    // }
    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }

    &.active {
      border-top: 2px;

      span {
        display: block;
        background: #fff;
      }
    }
  }
}

.ex-input ::v-deep .el-input__inner {
  padding-right: 50px !important;
}
</style>